"use client";

import { useTranslations } from "next-intl";
import Script from "next/script";
import { useState } from "react";

import { BlockLoader } from "@/common/components/block-loader";
import Button from "@/common/components/button";

export function FormScript({ formKey }: { formKey: string }) {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  return (
    <div className="flex w-full justify-center lg:block">
      {!scriptLoaded && <Skeleton />}
      <div data-fc-key={formKey}></div>
      <Script
        async
        src="/scripts/formcraft-embed.js"
        onLoad={() => setScriptLoaded(true)}
      ></Script>
    </div>
  );
}

function Skeleton() {
  const t = useTranslations("common");

  return (
    <div className="flex h-[580px] flex-col items-center rounded-lg bg-white p-8 shadow-[0_8px_16px_0px_rgba(0,0,0,0.16)]">
      <BlockLoader height={32} className="mb-3 w-9/12" />
      <BlockLoader height={32} className="mb-12 w-4/6" />
      <div className="flex w-full flex-col">
        <BlockLoader height={11} className="mb-2 w-12" />
        <BlockLoader height={40} className="mb-8" />
        <BlockLoader height={11} className="mb-2 w-20" />
        <BlockLoader height={40} className="mb-8" />
        <BlockLoader height={11} className="mb-2 w-20" />
        <BlockLoader height={40} className="mb-24" />
        <Button variant="smoke" className="bg-grey-20 h-12 !uppercase text-white" disabled>
          {t("button-submit-request")}
        </Button>
      </div>
    </div>
  );
}
